import { connect } from 'react-redux';
import { RefundCompletedExplorer } from '../../components';
import { getCompletedRefunds, addComment, uploadFiles, getRefundsCount, getTransactions } from '../../redux/actions/refunds';
import { getAllOperatorData as getOperatorData } from '../../redux/actions/operator';

const mapStateToProps = state => ({
  operators: state.operator.allData,
  refunds: state.refunds.data,
  pages: state.refunds.pages,
  total: state.refunds.total,
  users: state.refunds.users,
  loading: state.refunds.loading,
  refundCount: state.refunds.refundCount,
  transactions: state.refunds.transactions,
  loadingTransactions: state.refunds.loadingTransactions
});

const mapDispatchToProps = {
  getRefunds: getCompletedRefunds,
  getOperatorData,
  addComment,
  uploadFiles,
  getRefundsCount,
  getTransactions
};

export default connect(mapStateToProps, mapDispatchToProps)(RefundCompletedExplorer)



// WEBPACK FOOTER //
// ./src/containers/RefundCompletedExplorer/RefundExplorer.js